export default __webpack_public_path__ + "a58b915c26375f354ed28569273dd683.png";